import { VehicleInfoPage } from '@pages/vehicle-info-page'

export const NewWorkOrderPage = () => {
  return <VehicleInfoPage isNewWorkOrder={true} />
}
